import { FC } from 'react';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useMenuContext, useMenuState } from '#baseMenu/hooks';
import { AppSvgSpriteMonoIcon } from '#src/svg';

const ButtonHide: FC = () => {
  const { hide, isOpen } = useMenuContext();
  const { isActionsBlocked } = useMenuState();

  if (!isOpen) {
    return null;
  }

  return (
    <Button
      variant={ButtonVariant.white65}
      circle
      onClick={hide}
      additionalClassName="flex-shrink-0"
      aria-label="Hide menu"
      pointerEventsNone={isActionsBlocked}
    >
      <AppSvgSpriteMonoIcon name="cross" size={14} />
    </Button>
  );
};

export { ButtonHide };
